// src/components/DiveLoader.js
// Petit loader thématique (bulles qui remontent), réutilisable.
import React from "react";
import { useTranslation } from "react-i18next";
import "./DiveLoader.css";

export default function DiveLoader({ label }) {
    const { t } = useTranslation();
    const text = label !== undefined ? label : t("common.loading");
    return (
        <div className="dive-loader" role="status" aria-live="polite">
            <div className="dive-bubbles" aria-hidden="true">
                <span className="bubble b1" />
                <span className="bubble b2" />
                <span className="bubble b3" />
                <span className="bubble b4" />
                <span className="bubble b5" />
            </div>
            {text && <p className="dive-loader-text">{text}</p>}
        </div>
    );
}
